<template>
<div>
    <div role="alert" class="mcc-alert mcc-alert--primary-solid error-msg-div" style="margin-bottom:0px;">
        <div class="mcc-row">
            <div class="mcc-col mcc-col-8 error-msg">
                <p class="error-heading">You are not authorised to view this page!</p>
                <p class="error-body">Sorry, you’re not allowed to see this page. If you think you should, get an admin to change your permissions. </p>
                <button class="mcc-button mcc-button--outline mu-mx-sm-04" @click="logOut" title="Logout">
                    <mcc-icon name="logout_rounded" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Logout</span>
                </button>
            </div>
            <div class="mcc-col mcc-col-4 error-icon">
                <div class="mcc-filtered-icon__name">
                    <mcc-icon name="lock" aria-hidden="true" icon-set="fluency-color"></mcc-icon>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';
import constants from "../constants";

export default {
    name: "AuthorizationError",
    methods: {
        logOut: function () {
            axios.post(constants.BASE_URL + "/logout/unAuthorized", null, {
                    withCredentials: true
                }).then(response => console.log("User is logged out and cleared workplace selected by user"))
                .catch(error => console.log(" error occured while logging out is " + error));

            window.location = process.env.VUE_APP_CONTEXT_PATH + "/logout";
        }
    }
};
</script>

<style scoped>
.error-msg-div {
    max-width: 550px;
    margin: auto;
    padding: 25px;
    --mds-alert-accent-border-color: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.error-heading {
    font-size: 18px;
    font-weight: bolder;
    color: var(--mds-button-outline-color, var(--mds-text-color-default, #161616));
}

.error-icon {
    background-color: var(--mds-ui-color-02, #eeeef1);
    border-radius: 15px;
}

.mcc-filtered-icon__name {
    transform: translate(15%, 50%);
}

.mcc-icon {
    --mds-alert-base-icon-fill: var(--mds-button-outline-color, var(--mds-text-color-default, #161616))
}
</style>
